import _classCallCheck from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/spa-manager/spa-manager/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import { getSize, propTypes, defaultProps } from './common';
var currentId = 0;

var createIcon = function createIcon(iconDefinition) {
  var viewBox = [iconDefinition.xOffset || 0, iconDefinition.yOffset || 0, iconDefinition.width, iconDefinition.height].join(' ');
  var transform = iconDefinition.transform;

  var Icon =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Icon, _React$Component);

    function Icon() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Icon);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Icon)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "id", "icon-title-".concat(currentId++));

      return _this;
    }

    _createClass(Icon, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            size = _this$props.size,
            color = _this$props.color,
            title = _this$props.title,
            noStyle = _this$props.noStyle,
            noVerticalAlign = _this$props.noVerticalAlign,
            props = _objectWithoutProperties(_this$props, ["size", "color", "title", "noStyle", "noVerticalAlign"]);

        var hasTitle = Boolean(title);
        var heightWidth = getSize(size);
        var baseAlign = -.125 * Number.parseFloat(heightWidth);
        var style = noVerticalAlign ? null : {
          verticalAlign: "".concat(baseAlign, "em")
        };
        return React.createElement("svg", _extends({
          style: style,
          fill: color,
          height: heightWidth,
          width: heightWidth,
          viewBox: viewBox,
          "aria-labelledby": hasTitle ? this.id : null,
          "aria-hidden": hasTitle ? null : true,
          role: "img"
        }, props), hasTitle && React.createElement("title", {
          id: this.id
        }, title), React.createElement("path", {
          d: iconDefinition.svgPath,
          transform: transform
        }));
      }
    }]);

    return Icon;
  }(React.Component);

  _defineProperty(Icon, "displayName", iconDefinition.name);

  _defineProperty(Icon, "propTypes", propTypes);

  _defineProperty(Icon, "defaultProps", defaultProps);

  return Icon;
};

export default createIcon;